import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Pages/Home';
import About from './components/Pages/About';
import Blog from './components/Pages/Blog';
import BlogDetailsDializa from './components/Pages/BlogDetailsDializa';
import BlogDetailsDiabeti from './components/Pages/BlogDetailsDiabeti';
import BlogDetailsKanceri from './components/Pages/BlogDetailsKanceri';
import Contact from './components/Pages/Contact';
import Pharmacovigilance from './components/Pages/Pharmacovigilance';
import Services from './components/Pages/Services';
import { useEffect } from 'react';
import ErrorPage from './components/Pages/ErrorPage';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/dializa-peritoneale" element={<BlogDetailsDializa />} />
        <Route path="blog/diabeti" element={<BlogDetailsDiabeti />} />
        <Route path="blog/kanceri" element={<BlogDetailsKanceri />} />
        <Route path="contact" element={<Contact />} />
        <Route path="services" element={<Services />} />
        <Route path="pharmacovigilance" element={<Pharmacovigilance />} />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
